export enum KnowledgeEditorSource {
  SIDEBAR = 'sidebar',
  PLAYGROUND = 'playground',
  ENTRIES_TABLE = 'entries_table',
}
